import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Class11/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Class11/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Class11/3.jpg';
// import p4 from 'assests/Photos/FirldTrips/2023/Class11/4.jpg';
// import p5 from 'assests/Photos/FirldTrips/2023/Class11/5.jpg';
// import p6 from 'assests/Photos/FirldTrips/2023/Class10/6.jpg';
// import p7 from 'assests/Photos/FirldTrips/2023/Class10/7.jpg';
// import p8 from 'assests/Photos/FirldTrips/2023/Class10/8.jpg';
// import p9 from 'assests/Photos/FirldTrips/2023/Class10/9.jpg';
// import p10 from 'assests/Photos/FirldTrips/2023/Class10/10.jpg';
// import p11 from 'assests/Photos/FirldTrips/2023/Class10/11.jpg';
// import p12 from 'assests/Photos/FirldTrips/2023/Class10/12.jpg';
// import p13 from 'assests/Photos/FirldTrips/2023/Class10/13.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const CurricularClass112023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class11/1.webp`;
  const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class11/2.webp`;
  const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class11/3.webp`;
  const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class11/4.webp`;
  const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class11/5.webp`;


    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
       

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                ‘Field Trip to R D Nature’s Resort’
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 11   Date: 9 OCTOBER 2023

                                </Typography>
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The students of grade 11 undertook a field excursion to the R D Nature’s Resort located on the outskirts of Bangalore, on Monday 9 October, 2023. Soon after enjoying a delectable breakfast, the students joyfully explored the area's lush greenery and revelled in the nature’s bounty.
                                    <br />
                                    Activities like the Zip Line, River Crossing, Archery, Foosball and Shooting attracted the students' eager participation and was both entertaining and physically demanding. 
                                    <br />
                                    Students engaged in sports like Cricket and a few enjoyed Rain dancing and Pool activity after lunch. The day was wonderfully spent socializing, singing and having fun. The main attraction of the place was its natural rocks which engaged few students in Trekking and luxuriate the nature surrounding it. Students enjoyed delicious refreshments.
                                    <br />
                                    It was a wonderful opportunity for all the children to strengthen their bonds and they all returned to school rejuvenated. The excursion, undoubtedly, brought a dash of adventure and plenty of smiles on everyone’s face.
                                </Typography>
                            </Box>


                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar_2023 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default CurricularClass112023;